// Auto-generated by scripts/update-version.js — DO NOT EDIT MANUALLY
export const BUILD_NUMBER = 1792155325;
export const GIT_HASH = "f44963d";
